import React from 'react';

import { Select as E100Select } from 'e100-react-components';
import { SelectCloseButton } from '../SelectCloseButton/SelectCloseButton';

import { IPropTypes } from 'e100-react-components/lib/components/Select';

export const Select = ({
  showResetIcon = true,
  ...props
}: SelectProps) => {
  return (
    <E100Select
      {...props}
      {
        ...showResetIcon && {
          endAdornment: props.value ? (
            <SelectCloseButton
              onClick={() => {
                if (props.onChange) {
                  props.onChange({ target: { value: '' } } as any);
                }
              }}
            />
          ) : null
        }
      }
    />
  );
};

interface SelectProps extends IPropTypes {
  showResetIcon?: boolean;
}
